module.exports = "/matchcenter-staging/assets/images/novasport_5.25dd3988e54ed3947cf679161e51233c.png";